(() => {
  const bar = document.querySelector('[data-na-purchase-bar]');
  const offer = document.getElementById('NuxeroVisionSyncOffer');
  const primary = offer?.querySelector('button[name="add"]');
  if (!bar || !primary) return;
  bar.addEventListener('click', event => {
    const button = event.target.closest('[data-na-submit]');
    if (!button || button.disabled || primary.getAttribute('aria-disabled') === 'true') return;
    const target = offer.querySelector(`button[name="${button.dataset.naSubmit}"]`);
    target?.click();
  });
  if (!('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(entries => {
    const entry = entries[0];
    bar.hidden = entry.isIntersecting || entry.boundingClientRect.bottom >= 0;
  }, { threshold: 0 });
  observer.observe(primary);
  window.addEventListener('pagehide', () => observer.disconnect());
  window.addEventListener('pageshow', event => { if (event.persisted) observer.observe(primary); });
})();
